import { BackgroundColor } from '@ampcore/ampcom-contracts'

export const pillarBoxBackgroundColors = [
  BackgroundColor.DARK_MINT,
  BackgroundColor.BERRY,
  BackgroundColor.PURPLE,
  BackgroundColor.MINT,
  BackgroundColor.MIDNIGHT_BLUE,
  BackgroundColor.ORANGE,
  BackgroundColor.LIME_LIGHT,
  BackgroundColor.LIGHT_BLUE,
  BackgroundColor.DARK_GREY
] as const

export type PillarBoxBackgroundColor =
  (typeof pillarBoxBackgroundColors)[number]
